export const FICTIONAL_SCENARIO_DISCLAIMER =
  'This is a fictional, illustrative case created for education. It is not medical advice, diagnosis, or treatment, and does not describe a real person.'

/** Escape text for safe inclusion in HTML attributes and text nodes. */
export function escapeHtml(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
}

/** Strip tags for plain-text mirrors (.txt) used by LLM fetchers. */
export function htmlToPlainText(html: string): string {
  return html
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/(p|li|h1|h2|h3|section)>/gi, '\n')
    .replace(/<[^>]+>/g, '')
    .replace(/&quot;/g, '"')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/\n{3,}/g, '\n\n')
    .trim()
}
